import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgChevronDown = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 14,
	height: 8,
	viewBox: "0 0 14 8",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M12.8945 2.01172C13.332 1.60156 13.3594 0.917969 12.9219 0.480469C12.5117 0.0429688 11.8281 0.015625 11.3906 0.453125L7.125 4.52734L2.83203 0.453125C2.39453 0.015625 1.71094 0.0429688 1.30078 0.480469C0.863281 0.917969 0.890625 1.60156 1.32812 2.01172L6.35938 6.82422C6.57812 7.04297 6.85156 7.125 7.125 7.125C7.37109 7.125 7.64453 7.04297 7.86328 6.82422L12.8945 2.01172Z",
		fill: "#37474F"
	})]
});
const ForwardRef = forwardRef(SvgChevronDown);
export { ForwardRef as ReactComponent };
